export type AsideContext = 'commentary' | 'curated' | 'literature' | 'literature-list'

export const ALPHABET_OPTIONS = [
  { label: 'A', value: 'A' },
  { label: 'B', value: 'B' },
  { label: 'D', value: 'D' },
  { label: 'E', value: 'E' },
  { label: 'F', value: 'F' },
  { label: 'G', value: 'G' },
  { label: 'H', value: 'H' },
  { label: 'I', value: 'I' },
  { label: 'J', value: 'J' },
  { label: 'K', value: 'K' },
  { label: 'L', value: 'L' },
  { label: 'M', value: 'M' },
  { label: 'N', value: 'N' },
  { label: 'O', value: 'O' },
  { label: 'P', value: 'P' },
  { label: 'R', value: 'R' },
  { label: 'S', value: 'S' },
  { label: 'T', value: 'T' },
  { label: 'U', value: 'U' },
  { label: 'V', value: 'V' },
  { label: 'Y', value: 'Y' },
  { label: 'Å', value: 'Å' },
] as const

export const LAW_SORTING_OPTIONS = [
  { value: 'alfabetisk', label: 'Alfabetisk' },
  { value: 'kronologisk', label: 'Kronologisk' },
] as const
